/**
 * 公共模块
 */
/* eslint-disable */
import base from './base'
import axios from '@/utils/http'
import qs from 'qs'

const publicApi = {
  getUserByMid(params) {
    return axios.get(`${base.api}/coursecenter/iplate/getUserByMid`, params)
  },
  // 获取文件全路径
  getFullUrl(params) {
    return axios.get(`/rc/resourcecenter/getFullUrl`, { params })
  },
  myClassroom(param) {
    return axios.get(
      `${base.api}/studycenter/platform/classroom/myClassroom?${qs.stringify(param)}`,
    )
  },
  joinClassroom(params) {
    return axios.get(
      `${base.api}/studycenter/platform/classroom/joinClassroom?${qs.stringify(params)}`,
    )
  },
  publicCourse(params) {
    return axios.get(
      `${base.api}/studycenter/platform/course/publicCourse?${qs.stringify(params)}`
    )
  },
  hotRecommend(params) {
    return axios.get(
      `${base.api}/studycenter/platform/course/hotRecommend?${qs.stringify(params)}`
    )
  },
  termList() {
    return axios.post(
      `${base.api}/studycenter/platform/common/termList`
    )
  },
  getUserInfo() {
    return axios.post(
      `${base.api}/studycenter/platform/public/getUserInfo`
    )
  },
  myAssistClassroom(param) {
    return axios.get(
      `${base.api}/studycenter/platform/classroom/myAssistClassroom?${qs.stringify(param)}`
    )
  },
  classInfo(param) {
    return axios.post(
      `${base.api}/studycenter/platform/classroom/classInfo?${qs.stringify(param)}`
    )
  },
  getQrcodePath(param) {
    return axios.post(
      `${base.api}/studycenter/platform/classroom/getQrcodePath?${qs.stringify(param)}`
    )
  },
  // 爱课堂免密
  noPasswordLoginNew(params) {
    return axios.get(`/externalservice/thirdpartyUserService/noPasswordLoginNew`, {params})
  },

  //开放课程学习-章节列表
  getChapterResources(params) {
    return axios.get(
      `${base.externalservice}/studycenter/platform/openCourse/getChapterResources?${qs.stringify(params)}`
    )
  },
  //章节模块详情列表
  getResourceList(params) {
    return axios.get(
      `${base.externalservice}/studycenter/platform/openCourse/getResourceList?${qs.stringify(params)}`
    )
  },
  getChapterTalkList(params){//章节下全部话题
    return axios.get(
      `${base.externalservice}/studycenter/platform/talk/getChapterTalkList?${qs.stringify(params)}`
    )
  },
  getChapterMyTalkList(params){//章节下话题我参与的
    return axios.get(
      `${base.externalservice}/studycenter/platform/talk/getChapterMyTalkList?${qs.stringify(params)}`
    )
  },
  getQuestionListOfPaper(params){//未提交章节下测验
    return axios.get(
      `${base.externalservice}/studycenter/platform/question/getQuestionListOfPaper?${qs.stringify(params)}`
    )
  },
  getStudentSubmitPaper(params){//提交后章节下测验
    return axios.get(
      `${base.externalservice}/studycenter/platform/question/getStudentSubmitPaper?${qs.stringify(params)}`
    )
  },
  tempStorageStudentPaperAnswer(params){//暂存测验
    return axios.post(`${base.externalservice}/studycenter/platform/paper/tempStorageStudentPaperAnswer`, params)
  },
  saveStudyRecordChapter(params){//章节记录
    return axios.get(`${base.externalservice}/studycenter/platform/openCourse/saveStudyRecordChapter?${qs.stringify(params)}`)
  },
  storageStudentPaperAnswer(params){//提交测验
    return axios.post(`${base.externalservice}/studycenter/platform/paper/storageStudentPaperAnswer`, qs.stringify(params))
  },
  saveChapterResourceLearn(params){//测验记录
    return axios.post(`${base.externalservice}/coursecenter/thirdParty/resourceLog/finishLog`, qs.stringify(params))
  },
  getpages(params){//获取课件页数
    return axios.get(
      `${base.externalservice}/studycenter/platform/classroom/getResourcePageSize?${qs.stringify(params)}`
    )
  },
  videoFinishLog(params) {//课件倒计时
    return axios.get(
      `${base.api}/coursecenter/thirdParty/video/finishLog?`+qs.stringify(params)
    )
  },
  getPaperState(params){//章节下测验状态
    return axios.get(
      `${base.externalservice}/studycenter/platform/paper/getPaperState?${qs.stringify(params)}`
    )
  },
  myProgress(params) {
    return axios.get(
      `${base.api}/studycenter/platform/course/myProgress?${qs.stringify(params)}`
    )
  },
  getNoticeList(params) {
    return axios.post(`${base.api}/studycenter/platform/announcement/list`, qs.stringify(params))
  },
  attachments(params) {
    return axios.post(`${base.api}/studycenter/platform/announcement/attachments`, qs.stringify(params))
  },
  getMemList(params) {
    return axios.post(`${base.api}/studycenter/platform/openCourse/memberStatistic/list`, params)
  },
  getLearnStatistic(params) {
    return axios.post(`${base.api}/studycenter/platform/openCourse/memberRecord/getLearnStatistic`, qs.stringify(params))
  },
  getLearnTraces(params) {
    return axios.post(`${base.api}/studycenter/platform/openCourse/memberRecord/getLearnTraces`, qs.stringify(params))
  },
  addTopic(params) {
    return axios.post(`${base.api}/studycenter/platform/talk/save`, qs.stringify(params))
  },
  getMyTalkList(params) {
    return axios.get(
      `${base.api}/studycenter/platform/talk/getMyTalkList?${qs.stringify(params)}`
    )
  },
  getTalkPartitionList(params) {
    return axios.get(
      `${base.api}/studycenter/platform/talk/getTalkPartitionList?${qs.stringify(params)}`
    )
  },
  materialList(params) {
    return axios.get(
      `${base.api}/studycenter/platform/openCourse/materialList?${qs.stringify(params)}`
    )
  },
  // 资源预览
  viewCoursewareTeacher(params) {
    return axios.get(`${base.api}/coursecenter/courseLibrary/openCourse/viewCoursewareTeacher`, { params })
  },
  // 学生今日课程
  getWorkbench(params) {
    return axios.get(`${base.api}/studycenter/platform/homepage/timetable/Workbench`, { params })
  },
  // 收藏
  collect(params) {
    // return axios.post(`${base.api}/studyCenter/collect/insert`, { params })
    // console.log(params, JSON.stringify(params))
    return axios.post(`${base.api}/studycenter/platform/collect/insert`, JSON.stringify(params), {
      transformRequest: [
        function (data) {
          return data
        }
      ],
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  // 收藏
  deleteByContentId(params) {
    return axios.get(`${base.api}/studycenter/platform/collect/deleteByContentId`, { params })
  },
  // 获取当前课程
  getCourseBaseInfo(params) {
    return axios.get(`${base.api}/coursecenter/courseInfo/getCourseBaseInfo`, { params })
  },
  // 2. 学生完成视频课件的进度对外接口
  getProgressLog(params) {
    return axios.get(`${base.api}/coursecenter/thirdParty/video/progressLog`, { params })
  },
  // 应用列表
  getSchoolAppList() {
    return axios.get(`${base.api}/coursecenter/iplate/getSchoolAppList`)
  },
  //所有区域平台列表
  areaSchoolInfoBySchoolId() {
    return axios.get(`${base.api}/coursecenter/iplate/areaSchoolInfoBySchoolId`)
  },
  courseAreaSchoolInfo(params) {
    return axios.get(`${base.api}/studycenter/platform/openCourse/memberStatistic/courseAreaSchoolInfo?${qs.stringify(params)}`)
  },
  generalEducationSchoolList(params){
    return axios.get(`${base.api}/coursecenter/homepage/generalEducationSchoolList`)
  }

}

export default publicApi
